import { LeaderboardViewDTO } from '@neptune/shared/core-apis-leaderboard-domain';

import {
  ColumnModelConverter,
  GroupOptionsModelConverter,
  SortOptionsModelConverter,
  getStandardSortingOptions,
} from '@neptune/shared/leaderboard-domain';
import { isNotUndefined } from 'common/tsHelpers';

import { LeaderboardView } from './leaderboard-view-model';

export class LeaderboardViewConverter {
  static fromApiToDomain(lbView: LeaderboardViewDTO): LeaderboardView {
    const groupOptions = lbView.groupOptions
      ? GroupOptionsModelConverter.fromApiToDomain(lbView.groupOptions)
      : null;
    return {
      id: lbView.id,
      name: lbView.name,
      defaultView: lbView.defaultView,
      query: lbView.query,
      suggestionsEnabled: lbView.suggestionsEnabled,
      sortOptions:
        SortOptionsModelConverter.fromApiToLegacy(lbView.sortOptions) ||
        getStandardSortingOptions(),
      columnList: lbView.columnList.columns.map(ColumnModelConverter.columnFromApiToDomain),
      ...(groupOptions ? { groupOptions } : {}),
    };
  }
  static fromDomainToApi(lbView: LeaderboardView): LeaderboardViewDTO {
    return {
      id: lbView.id,
      name: lbView.name,
      defaultView: lbView.defaultView,
      query: lbView.query,
      suggestionsEnabled: lbView.suggestionsEnabled,
      sortOptions: SortOptionsModelConverter.fromLegacyToApi(lbView.sortOptions),
      columnList: {
        columns: lbView.columnList
          .map(ColumnModelConverter.columnFromDomainToApi)
          .filter(isNotUndefined),
      },
      groupOptions: lbView.groupOptions
        ? GroupOptionsModelConverter.fromDomainToApi(lbView.groupOptions)
        : undefined,
    };
  }
}
